// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var DragDrop$ReactHooksTemplate = require("../surveys/DragDrop.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var TicketHeader$ReactHooksTemplate = require("./ticketHeader.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var TicketHeadersApi$ReactHooksTemplate = require("./TicketHeadersApi.res.js");
var TicketHeadersClient$ReactHooksTemplate = require("./TicketHeadersClient.res.js");

var initialState_columnOrder = [];

var initialState = {
  dataFields: /* [] */0,
  ticketHeaders: /* [] */0,
  deletedHeaders: /* [] */0,
  columnOrder: initialState_columnOrder,
  searchFilter: "",
  showDropdown: false,
  error: "",
  edited: false,
  notification: undefined,
  dataFieldsLoading: true,
  ticketHeadersLoading: true
};

function insertDfTokenBeforeCreatedAt(columnOrder, token) {
  var i = Belt_Array.getIndexBy(columnOrder, (function (t) {
          return t === "created_at";
        }));
  if (i !== undefined) {
    return Belt_Array.concatMany([
                Belt_Array.slice(columnOrder, 0, i),
                [token],
                Belt_Array.slice(columnOrder, i, columnOrder.length - i | 0)
              ]);
  } else {
    return Js_array.concat(columnOrder, [token]);
  }
}

function labelForToken(token, headers) {
  switch (token) {
    case "assignee" :
        return "Assignee";
    case "created_at" :
        return "Created at";
    case "id" :
        return "Id";
    case "priority" :
        return "Priority";
    case "status" :
        return "Status";
    default:
      if (!token.startsWith("df_")) {
        return token;
      }
      var rest = token.slice(3);
      var dfId = Belt_Int.fromString(rest);
      if (dfId !== undefined) {
        return Belt_Option.getWithDefault(Belt_Option.map(Belt_List.getBy(headers, (function (h) {
                              return Caml_obj.equal(DataField$ReactHooksTemplate.id(TicketHeader$ReactHooksTemplate.dataField(h)), dfId);
                            })), (function (h) {
                          return DataField$ReactHooksTemplate.name(TicketHeader$ReactHooksTemplate.dataField(h));
                        })), token);
      } else {
        return token;
      }
  }
}

function dfTokenForDataField(df) {
  var id = DataField$ReactHooksTemplate.id(df);
  if (id !== undefined) {
    return "df_" + String(id);
  }
  
}

function dfTokenForHeader(h) {
  var id = DataField$ReactHooksTemplate.id(TicketHeader$ReactHooksTemplate.dataField(h));
  if (id !== undefined) {
    return "df_" + String(id);
  }
  
}

function TicketsHeaderPage(props) {
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = DragDrop$ReactHooksTemplate.useDragDrop(function (fromIdx, toIdx) {
        Curry._1(setState, (function (state) {
                return {
                        dataFields: state.dataFields,
                        ticketHeaders: state.ticketHeaders,
                        deletedHeaders: state.deletedHeaders,
                        columnOrder: DragDrop$ReactHooksTemplate.reorderColumnArray(fromIdx, toIdx, state.columnOrder),
                        searchFilter: state.searchFilter,
                        showDropdown: state.showDropdown,
                        error: state.error,
                        edited: true,
                        notification: state.notification,
                        dataFieldsLoading: state.dataFieldsLoading,
                        ticketHeadersLoading: state.ticketHeadersLoading
                      };
              }));
      });
  var getBlurClass = match$1[3];
  var handleDragDrop = match$1[2];
  var handleDragOver = match$1[1];
  var handleDragStart = match$1[0];
  var domElement = React.useRef(null);
  var handleOutsideClick = function ($$event) {
    var targetElement = $$event.target;
    var selectBoxElement = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
    if (!selectBoxElement.contains(targetElement)) {
      return Curry._1(setState, (function (state) {
                    return {
                            dataFields: state.dataFields,
                            ticketHeaders: state.ticketHeaders,
                            deletedHeaders: state.deletedHeaders,
                            columnOrder: state.columnOrder,
                            searchFilter: state.searchFilter,
                            showDropdown: false,
                            error: state.error,
                            edited: state.edited,
                            notification: state.notification,
                            dataFieldsLoading: state.dataFieldsLoading,
                            ticketHeadersLoading: state.ticketHeadersLoading
                          };
                  }));
    }
    
  };
  var fetchDataFields = function (param) {
    Js_promise.then_((function (dataFields) {
            return Promise.resolve(Curry._1(setState, (function (state) {
                              return {
                                      dataFields: dataFields,
                                      ticketHeaders: state.ticketHeaders,
                                      deletedHeaders: state.deletedHeaders,
                                      columnOrder: state.columnOrder,
                                      searchFilter: state.searchFilter,
                                      showDropdown: state.showDropdown,
                                      error: state.error,
                                      edited: state.edited,
                                      notification: state.notification,
                                      dataFieldsLoading: false,
                                      ticketHeadersLoading: state.ticketHeadersLoading
                                    };
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/data_fields?paginate=false", (function (param) {
                return Json_decode.field("data_fields", (function (param) {
                              return Json_decode.list(DataField$ReactHooksTemplate.decode, param);
                            }), param);
              })));
  };
  var fetchTicketHeaders = function (param) {
    Js_promise.then_((function (param) {
            var columnOrder = param[1];
            var ticketHeaders = param[0];
            Curry._1(setState, (function (state) {
                    return {
                            dataFields: state.dataFields,
                            ticketHeaders: ticketHeaders,
                            deletedHeaders: state.deletedHeaders,
                            columnOrder: columnOrder,
                            searchFilter: state.searchFilter,
                            showDropdown: state.showDropdown,
                            error: state.error,
                            edited: state.edited,
                            notification: state.notification,
                            dataFieldsLoading: state.dataFieldsLoading,
                            ticketHeadersLoading: false
                          };
                  }));
            return Promise.resolve();
          }), TicketHeadersClient$ReactHooksTemplate.fetchOverview());
  };
  React.useEffect((function (param) {
          document.addEventListener("mousedown", handleOutsideClick);
          fetchDataFields();
          fetchTicketHeaders();
          return (function (param) {
                    document.removeEventListener("mousedown", handleOutsideClick);
                  });
        }), []);
  var handleSelection = function (df) {
    var exists = Belt_List.getBy(state.ticketHeaders, (function (a) {
            return DataField$ReactHooksTemplate.name(TicketHeader$ReactHooksTemplate.dataField(a)) === DataField$ReactHooksTemplate.name(df);
          }));
    if (exists !== undefined) {
      var x = Caml_option.valFromOption(exists);
      var updatedDeletedList = Belt_List.add(state.deletedHeaders, x);
      var newList = Belt_List.keep(state.ticketHeaders, (function (a) {
              return !Caml_obj.equal(a, x);
            }));
      var dataFields = Belt_List.keep(state.dataFields, (function (a) {
              return !Caml_obj.equal(a, TicketHeader$ReactHooksTemplate.dataField(x));
            }));
      var tok = dfTokenForHeader(x);
      var nextColumnOrder = tok !== undefined ? Belt_Array.keep(state.columnOrder, (function (t) {
                return t !== tok;
              })) : state.columnOrder;
      return Curry._1(setState, (function (state) {
                    return {
                            dataFields: dataFields,
                            ticketHeaders: newList,
                            deletedHeaders: updatedDeletedList,
                            columnOrder: nextColumnOrder,
                            searchFilter: "",
                            showDropdown: false,
                            error: "",
                            edited: true,
                            notification: state.notification,
                            dataFieldsLoading: state.dataFieldsLoading,
                            ticketHeadersLoading: state.ticketHeadersLoading
                          };
                  }));
    }
    var emptyTicketHeader = TicketHeader$ReactHooksTemplate.empty();
    var selectedHeader = TicketHeader$ReactHooksTemplate.setDataField(emptyTicketHeader, df);
    var newList$1 = Belt_List.concat(state.ticketHeaders, {
          hd: selectedHeader,
          tl: /* [] */0
        });
    var dataFields$1 = Belt_List.keep(state.dataFields, (function (a) {
            return !Caml_obj.equal(a, df);
          }));
    var tok$1 = dfTokenForDataField(df);
    var nextColumnOrder$1 = tok$1 !== undefined ? insertDfTokenBeforeCreatedAt(state.columnOrder, tok$1) : state.columnOrder;
    Curry._1(setState, (function (state) {
            return {
                    dataFields: dataFields$1,
                    ticketHeaders: newList$1,
                    deletedHeaders: state.deletedHeaders,
                    columnOrder: nextColumnOrder$1,
                    searchFilter: "",
                    showDropdown: false,
                    error: "",
                    edited: true,
                    notification: state.notification,
                    dataFieldsLoading: state.dataFieldsLoading,
                    ticketHeadersLoading: state.ticketHeadersLoading
                  };
          }));
  };
  var dataFieldsList;
  if (state.searchFilter === "") {
    dataFieldsList = Belt_List.keep(state.dataFields, (function (v) {
            return !Belt_List.some(state.ticketHeaders, (function (ticketHeader) {
                          return DataField$ReactHooksTemplate.name(TicketHeader$ReactHooksTemplate.dataField(ticketHeader)) === DataField$ReactHooksTemplate.name(v);
                        }));
          }));
  } else {
    var dataFields = Belt_List.keep(state.dataFields, (function (v) {
            return !Belt_List.some(state.ticketHeaders, (function (ticketHeader) {
                          return DataField$ReactHooksTemplate.name(TicketHeader$ReactHooksTemplate.dataField(ticketHeader)) === DataField$ReactHooksTemplate.name(v);
                        }));
          }));
    dataFieldsList = Belt_List.keep(dataFields, (function (a) {
            return DataField$ReactHooksTemplate.name(a).toLowerCase().includes(state.searchFilter.toLowerCase());
          }));
  }
  var isLoading = state.dataFieldsLoading || state.ticketHeadersLoading;
  var customColumnCount = Belt_Array.keep(state.columnOrder, (function (t) {
          return t.startsWith("df_");
        })).length;
  var handleKeyDown = function ($$event) {
    var key = $$event.key;
    if (!(key === "Enter" && state.showDropdown && Belt_List.size(dataFieldsList) > 0)) {
      return ;
    }
    $$event.preventDefault();
    var availableOption = Belt_List.head(Belt_List.sort(dataFieldsList, (function (a, b) {
                return Caml.string_compare(DataField$ReactHooksTemplate.name(a), DataField$ReactHooksTemplate.name(b));
              })));
    if (availableOption !== undefined) {
      return handleSelection(Caml_option.valFromOption(availableOption));
    }
    
  };
  var alertType = state.notification;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "Ticket Headers",
                                      className: "text-lg font-semibold text-gray-900"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: "Choose which customer fields show in your ticket list and exports. Built-in columns stay pinned.",
                                      className: "text-sm text-gray-600 mt-1 max-w-2xl"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: "Custom columns: " + String(customColumnCount),
                                              className: "inline-flex items-center rounded-md border border-gray-200 bg-white px-3 py-1 text-xs text-gray-700 shadow-sm"
                                            }),
                                        state.edited ? JsxRuntime.jsx("span", {
                                                children: "Unsaved changes",
                                                className: "inline-flex items-center rounded-md border border-palatinateblue/20 bg-palatinateblue/5 px-3 py-1 text-xs text-palatinateblue font-medium shadow-sm"
                                              }) : null
                                      ],
                                      className: "mt-3 flex flex-wrap items-center gap-2"
                                    })
                              ]
                            }),
                        alertType !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                                            alertType: alertType,
                                            handleClose: (function (param) {
                                                Curry._1(setState, (function (state) {
                                                        return {
                                                                dataFields: state.dataFields,
                                                                ticketHeaders: state.ticketHeaders,
                                                                deletedHeaders: state.deletedHeaders,
                                                                columnOrder: state.columnOrder,
                                                                searchFilter: state.searchFilter,
                                                                showDropdown: state.showDropdown,
                                                                error: state.error,
                                                                edited: state.edited,
                                                                notification: undefined,
                                                                dataFieldsLoading: state.dataFieldsLoading,
                                                                ticketHeadersLoading: state.ticketHeadersLoading
                                                              };
                                                      }));
                                              })
                                          })
                                    }),
                                className: "absolute top-6 right-6 z-50"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("button", {
                                    children: "Save",
                                    className: state.edited && !isLoading ? "px-5 py-2 rounded bg-pigmentblue hover:bg-cetaceanblue text-sm text-white font-medium transition shadow-sm" : "px-5 py-2 rounded bg-pigmentblue text-sm text-white font-medium opacity-50 cursor-not-allowed",
                                    disabled: isLoading || !state.edited,
                                    onClick: (function (param) {
                                        var dfRank = function (columnOrder, dfToken) {
                                          var dfs = Belt_Array.keep(columnOrder, (function (x) {
                                                  return x.startsWith("df_");
                                                }));
                                          var i = Belt_Array.getIndexBy(dfs, (function (x) {
                                                  return x === dfToken;
                                                }));
                                          if (i !== undefined) {
                                            return i + 1 | 0;
                                          }
                                          var n = dfs.length;
                                          if (n > 0) {
                                            return n;
                                          } else {
                                            return 1;
                                          }
                                        };
                                        var encodeWithOrder = function (header) {
                                          var id = DataField$ReactHooksTemplate.id(TicketHeader$ReactHooksTemplate.dataField(header));
                                          if (id !== undefined) {
                                            var tok = "df_" + String(id);
                                            return TicketHeader$ReactHooksTemplate.encode(undefined, dfRank(state.columnOrder, tok), header);
                                          }
                                          var dfs = Belt_Array.keep(state.columnOrder, (function (x) {
                                                  return x.startsWith("df_");
                                                }));
                                          return TicketHeader$ReactHooksTemplate.encode(undefined, dfs.length + 1 | 0, header);
                                        };
                                        var headersWithPosition = Belt_List.map(state.ticketHeaders, encodeWithOrder);
                                        var encode = Belt_List.toArray(List.append(headersWithPosition, Belt_List.map(state.deletedHeaders, (function (x) {
                                                        return TicketHeader$ReactHooksTemplate.encode(true, undefined, x);
                                                      }))));
                                        var params = Json_encode.object_({
                                              hd: [
                                                "ticket_headers",
                                                Json_encode.object_({
                                                      hd: [
                                                        "ticket_headers_attributes",
                                                        encode
                                                      ],
                                                      tl: /* [] */0
                                                    })
                                              ],
                                              tl: {
                                                hd: [
                                                  "ticket_overview_column_order",
                                                  Json_encode.array((function (prim) {
                                                          return prim;
                                                        }), state.columnOrder)
                                                ],
                                                tl: /* [] */0
                                              }
                                            });
                                        Js_promise.then_((function (response) {
                                                var status = Json_decode.field("status", Json_decode.string, response);
                                                if (status === "success") {
                                                  var headers = Json_decode.field("ticket_headers", (function (param) {
                                                          return Json_decode.list(TicketHeader$ReactHooksTemplate.decode, param);
                                                        }), response);
                                                  var o = Json_decode.optional((function (param) {
                                                          return Json_decode.field("ticket_overview_column_order", (function (param) {
                                                                        return Json_decode.array(Json_decode.string, param);
                                                                      }), param);
                                                        }), response);
                                                  var orderRaw = o !== undefined ? o : [];
                                                  var columnOrder = TicketHeadersApi$ReactHooksTemplate.resolveColumnOrder(headers, orderRaw);
                                                  Curry._1(setState, (function (state) {
                                                          return {
                                                                  dataFields: state.dataFields,
                                                                  ticketHeaders: headers,
                                                                  deletedHeaders: /* [] */0,
                                                                  columnOrder: columnOrder,
                                                                  searchFilter: state.searchFilter,
                                                                  showDropdown: state.showDropdown,
                                                                  error: state.error,
                                                                  edited: false,
                                                                  notification: {
                                                                    TAG: "Success",
                                                                    _0: "Updated Ticket Headers"
                                                                  },
                                                                  dataFieldsLoading: state.dataFieldsLoading,
                                                                  ticketHeadersLoading: state.ticketHeadersLoading
                                                                };
                                                        }));
                                                } else {
                                                  Curry._1(setState, (function (state) {
                                                          return {
                                                                  dataFields: state.dataFields,
                                                                  ticketHeaders: state.ticketHeaders,
                                                                  deletedHeaders: state.deletedHeaders,
                                                                  columnOrder: state.columnOrder,
                                                                  searchFilter: state.searchFilter,
                                                                  showDropdown: state.showDropdown,
                                                                  error: state.error,
                                                                  edited: true,
                                                                  notification: {
                                                                    TAG: "Failure",
                                                                    _0: "Failed to add headers"
                                                                  },
                                                                  dataFieldsLoading: state.dataFieldsLoading,
                                                                  ticketHeadersLoading: state.ticketHeadersLoading
                                                                };
                                                        }));
                                                }
                                                return Promise.resolve();
                                              }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/tickets_header/add_header_to_user", params));
                                      })
                                  }),
                              className: "flex items-center gap-3"
                            })
                      ],
                      className: "flex justify-between items-start gap-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("h3", {
                                                      children: "Add columns",
                                                      className: "text-sm font-semibold text-gray-900"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "Search, add, then drag to reorder.",
                                                      className: "text-xs text-gray-600 mt-1"
                                                    })
                                              ]
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: "Selected",
                                                      className: "text-xs text-gray-500"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: String(customColumnCount),
                                                      className: "text-sm font-semibold text-gray-900"
                                                    })
                                              ],
                                              className: "text-right"
                                            })
                                      ],
                                      className: "flex items-start justify-between gap-4"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("input", {
                                                      className: "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10 disabled:opacity-70",
                                                      disabled: isLoading,
                                                      placeholder: "Search fields...",
                                                      type: "text",
                                                      value: state.searchFilter,
                                                      onKeyDown: handleKeyDown,
                                                      onFocus: (function (param) {
                                                          Curry._1(setState, (function (state) {
                                                                  return {
                                                                          dataFields: state.dataFields,
                                                                          ticketHeaders: state.ticketHeaders,
                                                                          deletedHeaders: state.deletedHeaders,
                                                                          columnOrder: state.columnOrder,
                                                                          searchFilter: state.searchFilter,
                                                                          showDropdown: true,
                                                                          error: state.error,
                                                                          edited: state.edited,
                                                                          notification: state.notification,
                                                                          dataFieldsLoading: state.dataFieldsLoading,
                                                                          ticketHeadersLoading: state.ticketHeadersLoading
                                                                        };
                                                                }));
                                                        }),
                                                      onChange: (function (e) {
                                                          var value = Utils$ReactHooksTemplate.formTargetValue(e);
                                                          Curry._1(setState, (function (state) {
                                                                  return {
                                                                          dataFields: state.dataFields,
                                                                          ticketHeaders: state.ticketHeaders,
                                                                          deletedHeaders: state.deletedHeaders,
                                                                          columnOrder: state.columnOrder,
                                                                          searchFilter: value,
                                                                          showDropdown: true,
                                                                          error: "",
                                                                          edited: state.edited,
                                                                          notification: state.notification,
                                                                          dataFieldsLoading: state.dataFieldsLoading,
                                                                          ticketHeadersLoading: state.ticketHeadersLoading
                                                                        };
                                                                }));
                                                        })
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx("svg", {
                                                            children: JsxRuntime.jsx("path", {
                                                                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
                                                                  strokeLinecap: "round",
                                                                  strokeLinejoin: "round",
                                                                  strokeWidth: "2"
                                                                }),
                                                            className: "w-4 h-4 text-gray-400",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            viewBox: "0 0 24 24"
                                                          }),
                                                      className: "absolute right-3 top-1/2 transform -translate-y-1/2"
                                                    })
                                              ],
                                              className: "relative"
                                            }),
                                        state.showDropdown && Belt_List.size(dataFieldsList) > 0 ? JsxRuntime.jsx("div", {
                                                children: $$Array.of_list(Belt_List.map(Belt_List.sort(dataFieldsList, (function (a, b) {
                                                                return Caml.string_compare(DataField$ReactHooksTemplate.name(a), DataField$ReactHooksTemplate.name(b));
                                                              })), (function (df) {
                                                            return JsxRuntime.jsx("button", {
                                                                        children: DataField$ReactHooksTemplate.name(df),
                                                                        className: "w-full text-left px-3 py-2 text-sm cursor-pointer hover:bg-gray-50 transition border-b border-gray-100 last:border-b-0",
                                                                        onClick: (function (param) {
                                                                            handleSelection(df);
                                                                          })
                                                                      }, DataField$ReactHooksTemplate.name(df));
                                                          }))),
                                                className: "absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto"
                                              }) : null,
                                        state.showDropdown && Belt_List.size(dataFieldsList) === 0 ? JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("div", {
                                                      children: state.searchFilter !== "" ? "No matching fields found" : "All available fields are already selected",
                                                      className: "px-3 py-2 text-sm text-gray-500"
                                                    }),
                                                className: "absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg"
                                              }) : null
                                      ],
                                      ref: Caml_option.some(domElement),
                                      className: "mt-4 relative"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: "Tip",
                                              className: "text-xs font-medium text-gray-700"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: "Built-in columns cannot be removed.",
                                              className: "text-xs text-gray-600 mt-1"
                                            })
                                      ],
                                      className: "mt-4 rounded-lg border border-gray-200 bg-gray-50 p-3"
                                    })
                              ],
                              className: "bg-white border border-gray-200 rounded-xl shadow-sm p-5 xl:col-span-1"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("h3", {
                                                      children: "Column order",
                                                      className: "text-sm font-semibold text-gray-900"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: "Drag rows to set order in the ticket overview and exports.",
                                                      className: "text-xs text-gray-600 mt-1"
                                                    })
                                              ]
                                            }),
                                        state.edited ? JsxRuntime.jsx("span", {
                                                children: "Reorder pending",
                                                className: "inline-flex items-center rounded-md border border-palatinateblue/20 bg-palatinateblue/5 px-3 py-1 text-xs text-palatinateblue font-medium"
                                              }) : null
                                      ],
                                      className: "flex items-start justify-between gap-4 mb-3"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("div", {
                                                            children: "Drag",
                                                            className: "w-24"
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: "Column",
                                                            className: "flex-1"
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: "Action",
                                                            className: "w-24 text-center"
                                                          })
                                                    ],
                                                    className: "flex items-center gap-4"
                                                  }),
                                              className: "sticky top-0 z-5 bg-gray-50 border-b border-gray-200 px-4 py-3 text-xs font-medium text-gray-700"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: isLoading ? $$Array.of_list({
                                                      hd: JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    JsxRuntime.jsx("div", {
                                                                          children: JsxRuntime.jsx("div", {
                                                                                className: "h-4 w-10 bg-gray-200 rounded"
                                                                              }),
                                                                          className: "w-24"
                                                                        }),
                                                                    JsxRuntime.jsx("div", {
                                                                          children: JsxRuntime.jsx("div", {
                                                                                className: "h-4 w-full bg-gray-200 rounded"
                                                                              }),
                                                                          className: "flex-1"
                                                                        }),
                                                                    JsxRuntime.jsx("div", {
                                                                          children: JsxRuntime.jsx("div", {
                                                                                className: "h-4 w-8 bg-gray-200 rounded"
                                                                              }),
                                                                          className: "w-24 flex justify-center"
                                                                        })
                                                                  ],
                                                                  className: "flex items-center gap-4"
                                                                }),
                                                            className: "animate-pulse px-4 py-3"
                                                          }, "sk-1"),
                                                      tl: {
                                                        hd: JsxRuntime.jsx("div", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: JsxRuntime.jsx("div", {
                                                                                  className: "h-4 w-10 bg-gray-200 rounded"
                                                                                }),
                                                                            className: "w-24"
                                                                          }),
                                                                      JsxRuntime.jsx("div", {
                                                                            children: JsxRuntime.jsx("div", {
                                                                                  className: "h-4 w-3/4 bg-gray-200 rounded"
                                                                                }),
                                                                            className: "flex-1"
                                                                          }),
                                                                      JsxRuntime.jsx("div", {
                                                                            children: JsxRuntime.jsx("div", {
                                                                                  className: "h-4 w-8 bg-gray-200 rounded"
                                                                                }),
                                                                            className: "w-24 flex justify-center"
                                                                          })
                                                                    ],
                                                                    className: "flex items-center gap-4"
                                                                  }),
                                                              className: "animate-pulse px-4 py-3"
                                                            }, "sk-2"),
                                                        tl: {
                                                          hd: JsxRuntime.jsx("div", {
                                                                children: JsxRuntime.jsxs("div", {
                                                                      children: [
                                                                        JsxRuntime.jsx("div", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    className: "h-4 w-10 bg-gray-200 rounded"
                                                                                  }),
                                                                              className: "w-24"
                                                                            }),
                                                                        JsxRuntime.jsx("div", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    className: "h-4 w-2/3 bg-gray-200 rounded"
                                                                                  }),
                                                                              className: "flex-1"
                                                                            }),
                                                                        JsxRuntime.jsx("div", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    className: "h-4 w-8 bg-gray-200 rounded"
                                                                                  }),
                                                                              className: "w-24 flex justify-center"
                                                                            })
                                                                      ],
                                                                      className: "flex items-center gap-4"
                                                                    }),
                                                                className: "animate-pulse px-4 py-3"
                                                              }, "sk-3"),
                                                          tl: {
                                                            hd: JsxRuntime.jsx("div", {
                                                                  children: JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("div", {
                                                                                      className: "h-4 w-10 bg-gray-200 rounded"
                                                                                    }),
                                                                                className: "w-24"
                                                                              }),
                                                                          JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("div", {
                                                                                      className: "h-4 w-5/6 bg-gray-200 rounded"
                                                                                    }),
                                                                                className: "flex-1"
                                                                              }),
                                                                          JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("div", {
                                                                                      className: "h-4 w-8 bg-gray-200 rounded"
                                                                                    }),
                                                                                className: "w-24 flex justify-center"
                                                                              })
                                                                        ],
                                                                        className: "flex items-center gap-4"
                                                                      }),
                                                                  className: "animate-pulse px-4 py-3"
                                                                }, "sk-4"),
                                                            tl: /* [] */0
                                                          }
                                                        }
                                                      }
                                                    }) : Belt_Array.mapWithIndex(state.columnOrder, (function (index, token) {
                                                        var isDf = token.startsWith("df_");
                                                        var dfId = Belt_Int.fromString(token.slice(3));
                                                        var headerForRow = dfId !== undefined ? Belt_List.getBy(state.ticketHeaders, (function (h) {
                                                                  return Caml_obj.equal(DataField$ReactHooksTemplate.id(TicketHeader$ReactHooksTemplate.dataField(h)), dfId);
                                                                })) : undefined;
                                                        var tmp;
                                                        if (isDf) {
                                                          if (headerForRow !== undefined) {
                                                            var h = Caml_option.valFromOption(headerForRow);
                                                            tmp = JsxRuntime.jsx("button", {
                                                                  children: JsxRuntime.jsx("img", {
                                                                        className: "h-5 w-5",
                                                                        src: Image$ReactHooksTemplate.trash
                                                                      }),
                                                                  className: "inline-flex items-center justify-center rounded-md p-2 text-gray-500 hover:bg-red-50 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-200 transition",
                                                                  onClick: (function (param) {
                                                                      var updatedDeletedList = Belt_List.add(state.deletedHeaders, h);
                                                                      var newList = Belt_List.keep(state.ticketHeaders, (function (a) {
                                                                              return !Caml_obj.equal(a, h);
                                                                            }));
                                                                      var tok = dfTokenForHeader(h);
                                                                      var nextColumnOrder = tok !== undefined ? Belt_Array.keep(state.columnOrder, (function (t) {
                                                                                return t !== tok;
                                                                              })) : state.columnOrder;
                                                                      Curry._1(setState, (function (state) {
                                                                              return {
                                                                                      dataFields: state.dataFields,
                                                                                      ticketHeaders: newList,
                                                                                      deletedHeaders: updatedDeletedList,
                                                                                      columnOrder: nextColumnOrder,
                                                                                      searchFilter: "",
                                                                                      showDropdown: false,
                                                                                      error: "",
                                                                                      edited: true,
                                                                                      notification: state.notification,
                                                                                      dataFieldsLoading: state.dataFieldsLoading,
                                                                                      ticketHeadersLoading: state.ticketHeadersLoading
                                                                                    };
                                                                            }));
                                                                    })
                                                                });
                                                          } else {
                                                            tmp = null;
                                                          }
                                                        } else {
                                                          tmp = JsxRuntime.jsx("span", {
                                                                children: "Default",
                                                                className: "inline-flex items-center rounded-md border border-gray-200 bg-gray-50 px-2 py-1 text-xs font-medium text-gray-500 cursor-not-allowed",
                                                                title: "Built-in/default columns cannot be removed"
                                                              });
                                                        }
                                                        return JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx("div", {
                                                                            children: "⋮⋮",
                                                                            className: "w-24 text-gray-500 text-xs"
                                                                          }),
                                                                      JsxRuntime.jsx("div", {
                                                                            children: JsxRuntime.jsxs("div", {
                                                                                  children: [
                                                                                    JsxRuntime.jsx("div", {
                                                                                          children: labelForToken(token, state.ticketHeaders),
                                                                                          className: "text-gray-900 text-sm font-medium truncate min-w-0"
                                                                                        }),
                                                                                    isDf ? null : JsxRuntime.jsx("span", {
                                                                                            children: "Built-in",
                                                                                            className: "inline-flex items-center rounded-md border border-gray-200 bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-600"
                                                                                          })
                                                                                  ],
                                                                                  className: "flex items-center gap-2 min-w-0"
                                                                                }),
                                                                            className: "flex-1 min-w-0"
                                                                          }),
                                                                      JsxRuntime.jsx("div", {
                                                                            children: tmp,
                                                                            className: "w-24 flex justify-center"
                                                                          })
                                                                    ],
                                                                    className: "px-4 py-3 flex items-center gap-4 hover:bg-gray-50 transition-colors cursor-grab active:cursor-grabbing " + Curry._1(getBlurClass, index),
                                                                    draggable: true,
                                                                    onDragOver: (function (e) {
                                                                        Curry._2(handleDragOver, index, e);
                                                                      }),
                                                                    onDragStart: (function (e) {
                                                                        Curry._2(handleDragStart, index, e);
                                                                      }),
                                                                    onDrop: Curry._1(handleDragDrop, index)
                                                                  }, token + ("-" + String(index)));
                                                      })),
                                              className: "divide-y divide-gray-200"
                                            })
                                      ],
                                      className: "w-full max-h-96 overflow-y-auto rounded-lg border border-gray-200 bg-white"
                                    })
                              ],
                              className: "bg-white border border-gray-200 rounded-xl shadow-sm p-5 xl:col-span-2"
                            })
                      ],
                      className: "grid grid-cols-1 xl:grid-cols-3 gap-6 items-start"
                    })
              ],
              className: "p-8 space-y-6 h-full w-full relative bg-gradient-to-b from-gray-50 to-white"
            });
}

var make = TicketsHeaderPage;

exports.initialState = initialState;
exports.insertDfTokenBeforeCreatedAt = insertDfTokenBeforeCreatedAt;
exports.labelForToken = labelForToken;
exports.dfTokenForDataField = dfTokenForDataField;
exports.dfTokenForHeader = dfTokenForHeader;
exports.make = make;
/* react Not a pure module */
